import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f171139"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-fixed tw-inset-0 tw-z-40"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-bg tw-absolute tw-inset-0 tw-z-modal tw-bg-mainbg1 tw-opacity-75" }, null, -1))
const _hoisted_4 = { class: "sf-dialog-container" }
const _hoisted_5 = { class: "tw-h-full" }
const _hoisted_6 = { class: "tw-px-4 md:tw-px-12" }
const _hoisted_7 = { class: "modal-title" }
const _hoisted_8 = {
  key: 0,
  class: "tw-absolute tw-top-1 tw-right-0 tw-text-lg tw-py-2 tw-px-4"
}
const _hoisted_9 = { class: "mdtall:tw-hidden" }
const _hoisted_10 = { class: "tw-hidden mdtall:tw-block" }
const _hoisted_11 = {
  ref: "scrollable",
  class: "slotp tw-px-6 md:tw-px-12"
}
const _hoisted_12 = {
  key: 0,
  class: "sf-modal-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseX = _resolveComponent("CloseX")!

  return (_ctx.componentIsActive)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_Transition, {
          name: "fade",
          onAfterLeave: _ctx.dialogClosed,
          onBeforeEnter: _ctx.dialogBeforeShow,
          onAfterEnter: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('shown')))
        }, {
          default: _withCtx(() => [
            (_ctx.isShowing)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("div", {
                    class: _normalizeClass(["sf-modal tw-absolute tw-inset-0 tw-z-modal tw-text-center tw-h-full", _ctx.modalSize]),
                    onMousedown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.bgWillHide = _ctx.closeOnBg)),
                    onMouseup: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onBgClose && _ctx.onBgClose(...args)))
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["sf-dialog", _ctx.footerBehavior]),
                          onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                          onMouseup: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.bgWillHide = false), ["stop"]))
                        }, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _renderSlot(_ctx.$slots, "title", {}, undefined, true)
                            ]),
                            (_ctx.canClose)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  _createElementVNode("div", _hoisted_9, [
                                    _createVNode(_component_CloseX, {
                                      size: "28px",
                                      onClick: _ctx.onClose
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _createElementVNode("div", _hoisted_10, [
                                    _createVNode(_component_CloseX, {
                                      size: "38px",
                                      onClick: _ctx.onClose
                                    }, null, 8, ["onClick"])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _renderSlot(_ctx.$slots, "default", { scroll: _ctx.scrollContent }, undefined, true),
                            (_ctx.isSimple)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  (_ctx.simpleOkLabel)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('ok')), ["prevent"])),
                                        class: "sf-btn-primary"
                                      }, _toDisplayString(_ctx.simpleOkLabel), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.simpleCancelLabel)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel'))),
                                        class: "sf-btn-secondary"
                                      }, _toDisplayString(_ctx.simpleCancelLabel), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 512)
                        ], 34)
                      ])
                    ])
                  ], 34)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["onAfterLeave", "onBeforeEnter"])
      ]))
    : _createCommentVNode("", true)
}